<template>
  <div class="skeleton-chart" :style="{ height: height }">
    <div v-if="showGradient" class="chart-gradient"></div>
  </div>
</template>

<script>
export default {
  name: 'SkeletonChart',
  props: {
    height: {
      type: String,
      default: '300px'
    },
    showGradient: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style scoped>
.skeleton-chart {
  border-radius: 8px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  position: relative;
  overflow: hidden;
}

.chart-gradient {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 60%;
  background: linear-gradient(to top, rgba(88, 149, 255, 0.1), transparent);
}

@keyframes shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}
</style>
